import "lazysizes";

import Swup from "swup";
import SwupPreloadPlugin from "@swup/preload-plugin";
import SwupScrollPlugin from "@swup/scroll-plugin";
import SwupBodyClassPlugin from "@swup/body-class-plugin";

import Swiper, { Autoplay, EffectFade } from "swiper";
// Swiper.use([Autoplay, EffectFade]);

import { intro } from "./components/intro";
import { nav } from "./components/nav";
import { overlay } from "./components/overlay";
import { collapsibleText } from "./components/collapsible-text";
import { collapsibleSection } from "./components/collapsible-section";
// import { gallery } from "./components/gallery";
import Lightbox from "./components/lightbox";
import { filters } from "./components/filters";
// import { loopCards } from "./components/loop-cards";


window.main = window.main || {};

let isHomepage = false;
let isProjectPage = false;
let isTouchDevice = false;
let isNavToggled = false;
let isOverlayToggled = false;
let isOverlayWechatToggled = false;
let isPanelToggled = false;
let introRan = false;
let sliderdesktopRan = false;
let slidermobileRan = false;

let swiper1;
let swiper2;

function checks() {
  function checkIfTouchDevice() {
    return (
      true ==
      ("ontouchstart" in window ||
        (window.DocumentTouch && document instanceof DocumentTouch))
    );
  }

  if (checkIfTouchDevice() === true) {
    document.body.classList.add("is-touch");
    document.body.classList.add("is-mobile-device");
    isTouchDevice = true;
  } else {
    isTouchDevice = false;
  }

  if (document.body.classList.contains("page-home")) {
    isHomepage = true;
  } else {
    isHomepage = false;
  }

  if (document.body.classList.contains("page-project")) {
    isProjectPage = true;
  } else {
    isProjectPage = false;
  }

  if (isHomepage == false) {
    document.body.setAttribute("data-text", "black");
    if (sliderdesktopRan == true) {
      swiper1.destroy();
      sliderdesktopRan = false;
    }
    if (slidermobileRan == true) {
      swiper2.destroy();
      slidermobileRan = false;
    }
  }
}

function setupPlugins() {
  function initSwup() {
    const options = {
      animationSelector: '[class*="transition-fade"]',
      animateHistoryBrowsing: true,
      containers: ["#main", ".js-header"],
      plugins: [
        new SwupPreloadPlugin(),
        new SwupScrollPlugin({
          animateScroll: false,
        }),
        new SwupBodyClassPlugin({
          prefix: "page-",
        }),
      ],
    };

    const swup = new Swup(options);

    swup.on("contentReplaced", () => {
      checks();
      swupReload();
      swupActiveLinks(); // trigger after swup
    });
  }

  const sliderdesktop = document.querySelector(".swiper-container-1");
  if (typeof sliderdesktop != "undefined" && sliderdesktop != null) {
    var sliderdesktopstate = sliderdesktop.currentStyle
      ? sliderdesktop.currentStyle.display
      : getComputedStyle(sliderdesktop, null).display;

    if (sliderdesktopstate != "none") {
      swiper1 = new Swiper(".swiper-container-1", {
        modules: [Autoplay, EffectFade],
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        speed: 1000,
        autoplay: {
          delay: 5000,
          pauseOnMouseEnter: false,
          disableOnInteraction: false,
        },
        loop: true,
        on: {
          transitionStart: function () {
            console.log("transition");
            let index1 = this.realIndex + 1; /* slide 1 => slides[1] */
            let current_data1 = this.slides[index1].dataset.text;
            document.body.setAttribute("data-text", current_data1);
          },
        },
      });
      sliderdesktopRan = true;
    }
  }

  const slidermobile = document.querySelector(".swiper-container-2");
  if (typeof slidermobile != "undefined" && slidermobile != null) {
    var slidermobilestate = slidermobile.currentStyle
      ? slidermobile.currentStyle.display
      : getComputedStyle(slidermobile, null).display;

    if (slidermobilestate != "none") {
      swiper2 = new Swiper(".swiper-container-2", {
        modules: [Autoplay, EffectFade],
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        speed: 1000,
        autoplay: {
          delay: 5000,
          pauseOnMouseEnter: false,
          disableOnInteraction: false,
        },
        loop: true,
        on: {
          transitionStart: function () {
            let index2 = this.realIndex + 1; /* slide 1 => slides[1] */
            let current_data2 = this.slides[index2].dataset.text;
            document.body.setAttribute("data-text", current_data2);
          },
        },
      });
      slidermobileRan = true;
    }
  }

  initSwup();

}

function swupActiveLinks() {
  let currentPath = window.location.pathname;
  let links = document.querySelectorAll("nav a"); // <- put your link selector here
  for (const link of links) {
    let linkPath = new URL(link.href).pathname;
    link.ariaCurrent = linkPath == currentPath ? "page" : false;
  }
}

function swupReload() {
  document.body.setAttribute("data-menu-open", "false");
  document.body.classList.remove("no-scroll");
  isNavToggled = false;

  intro(introRan, isHomepage);
  nav(isNavToggled, isPanelToggled);
  overlay(isOverlayToggled, isOverlayWechatToggled);
  collapsibleText();
  collapsibleSection();
  filters();
  // loopCards();

  if (isProjectPage) {
    const lb = new Lightbox({
      selector: '[data-rel="aiLightbox"]', // string
      lazyload: true, // boolean
      arrows: true, // boolean
      counter: true, // boolean
      slideSpeed: 500, //number(ms)
    });
  }

}

function init() {

  if (history.scrollRestoration) {
    history.scrollRestoration = "manual";
  }

  const introelement = document.getElementById("intro");
  if (typeof introelement != "undefined" && introelement != null) {
    intro(introRan, isHomepage);
    introRan = true;
  }

  nav(isNavToggled);
  overlay(isOverlayToggled, isOverlayWechatToggled);
  collapsibleText();
  collapsibleSection();
  filters();
  // loopCards();

  if (isProjectPage) {
    const lb = new Lightbox({
      selector: '[data-rel="aiLightbox"]', // string
      lazyload: true, // boolean
      arrows: true, // boolean
      counter: true, // boolean
      slideSpeed: 500, //number(ms)
    });
  }

}

checks();
setupPlugins();
init();
